// @flow
import { createContext } from 'react';

import { defaultVerifications, type VerificationStateType } from './useVerificationsData';


type VerificationContextType = [
  VerificationStateType, {
    requestVerifications: (solutionId: number | void) => Promise<boolean> | boolean,
    deleteVerificationBySolutionId: (solutionId: number) => void
  }
]

const defaultContext: VerificationContextType = [
  defaultVerifications, {
    requestVerifications: () => false,
    deleteVerificationBySolutionId: () => {},
  },
];

const x: any = createContext<VerificationContextType>(defaultContext);
export default x;
